var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15088_106519)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_15088_106519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 6C12.8005 6 11.6665 6.30516 10.6453 6.78181L12.0833 8.21975C12.6867 8.01906 13.33 7.90625 14 7.90625C17.3599 7.90622 20.0937 10.64 20.0937 13.9999C20.0937 17.3599 17.3599 20.0937 13.9999 20.0937C10.6399 20.0937 7.90622 17.3599 7.90622 13.9999C7.90622 13.3299 8.01906 12.6867 8.21972 12.0832L6.78178 10.6453C6.30519 11.6665 6 12.8005 6 13.9999C6 18.394 9.60591 21.9999 13.9999 21.9999C18.394 21.9999 21.9999 18.394 21.9999 13.9999C21.9999 9.60591 18.394 6 13.9999 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3375 13.6776L14.3345 13.6731L14.3314 13.6685L11.6563 10.9934V9.31246C11.6563 9.18792 11.6069 9.06892 11.519 8.98102L8.70649 6.1373C8.57284 6.00367 8.37096 5.96292 8.19562 6.03571C8.02031 6.10802 7.90631 6.27924 7.90631 6.46874V7.87499H6.46881C6.27934 7.87496 6.10812 7.98892 6.03581 8.16427C5.96303 8.33958 6.00331 8.54102 6.13743 8.67514L8.98118 11.5189C9.06909 11.6068 9.18809 11.6562 9.31259 11.6562H10.9935L13.6686 14.3313L13.6732 14.3344L13.6777 14.3374C13.8602 14.5116 14.1374 14.5139 14.3224 14.3374C14.5171 14.1515 14.5127 13.8612 14.3375 13.6776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5937 10.0404C13.0357 9.88281 13.5045 9.78125 14 9.78125C16.3263 9.78125 18.2187 11.6736 18.2187 14C18.2187 16.3263 16.3263 18.2187 14 18.2187C11.6737 18.2187 9.78125 16.3263 9.78125 14C9.78125 13.5045 9.88281 13.0358 10.0404 12.5937H10.6052L11.6888 13.6774C11.6868 13.6922 11.6847 13.707 11.6825 13.7218C11.6694 13.8133 11.6562 13.9049 11.6562 14C11.6562 15.2923 12.7077 16.3438 14 16.3438C15.2922 16.3438 16.3437 15.2923 16.3437 14C16.3437 12.7077 15.2922 11.6563 14 11.6563C13.9049 11.6563 13.8133 11.6694 13.7218 11.6825C13.707 11.6847 13.6922 11.6868 13.6774 11.6889L12.5937 10.6052V10.0404Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15088_106519",
    x1: 34.2332,
    y1: 21.7668,
    x2: 21.7668,
    y2: -6.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE29CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5326BD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15088_106519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionsIcon);
export default __webpack_public_path__ + "static/media/Missions_Icon.b46ba60b78e5d259440cfe1642e1ffaa.svg";
export { ForwardRef as ReactComponent };